<div class="terms-and-conditions-wrapper">
    <section class="terms-conditions-list" *ngIf="showListing">
        <div class="container">
            <div class="row">
                <div class="col-12 title text-right">
                    <span class="">
                      <img src="assets/icon/clear.svg" width="25" height="25" (click)="closeSheet();crossBtnGA()" style="cursor: pointer;"
                        alt="close" />
                    </span>
                  </div>
            </div>
            <div class="row">
                <div class="col-12 title pt-2 pb-4">
                    <h2>Terms and Conditions</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-12" *ngFor="let item of tncData;let index = index">
                    <div class="tc-content" (click)="goToView(index)">
                        <p>
                            <span class="title">{{item.attributes.title}} </span>
                        </p>
                        <p> <img src="assets/icon/arrow_right_grey.svg" alt="right-arrow-icon"></p>     
                    </div>
                    <hr>
                </div>
            </div>
        </div>
    </section>
    <section class="view-terms-condition" *ngIf="!showListing">
        <div class="container">
            <div class="row pt-2">
                <div class="col-md-8">
                  <p class="back-txt" (click)="gotoListing()">BACK</p>
                </div>
                <div class="col-md-4 title text-right d-m-none">
                  <span class="d-none d-sm-block">
                    <img src="assets/icon/clear.svg" width="25" height="25" (click)="closeSheet();crossBtnGA()" style="cursor: pointer;"
                      alt="close" />
                  </span>
                </div>
            </div>
        </div>
        <div class="tnc-wrapper container flex">
            <div class="mr-1rem">
                <img src="assets/icon/tnc.svg" alt="tnc_logo">
            </div>
            <div>
                <h1 class="title">{{pageTitle}}</h1>
                <p class="sub-title">For Dine-in and Takeaway in Select Stores.</p>
                <label class="status">Last updated {{updatedDateTime}}</label>
            </div>
        </div>
        <hr>
        <div class="container">
            <div class="terms-details" [innerHTML]='tnCData | safeHtml' *ngIf="tncData != ''"></div>
        </div>
    </section>
</div>